// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4712":"10517a7d","7383":"ae3e43b1","7985":"c9f8e750"}[chunkId] + ".css";
};